/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Invalid_RequestInputs */

const en_two_fa_invalid_request = /** @type {(inputs: Two_Fa_Invalid_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid two-factor request`)
};

const nl_two_fa_invalid_request = /** @type {(inputs: Two_Fa_Invalid_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige twee-factor aanvraag`)
};

/**
* | output |
* | --- |
* | "Invalid two-factor request" |
*
* @param {Two_Fa_Invalid_RequestInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_invalid_request = /** @type {((inputs?: Two_Fa_Invalid_RequestInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Invalid_RequestInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_invalid_request(inputs)
	return en_two_fa_invalid_request(inputs)
});